import { Helmet } from 'react-helmet';
import RegisterConfirmationStepForm from './RegisterConfirmationBisStepForm/RegisterConfirmationBisStepForm';

export default () => {
  return (
    <>
      <Helmet>
        <title>Inscription</title>
      </Helmet>
      <RegisterConfirmationStepForm />
    </>
  );
};
